export default __webpack_public_path__ + "static/media/dog-badge-selected.0c9d75f2.svg";